module.exports = __webpack_public_path__ + "img/logoNHS.d7f45d09.png";